import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import { Button } from 'antd';

type ToggleChartInteractionProps = {
  isInteractive: boolean;
  onToggle: () => void;
};

const ToggleChartInteraction = ({ isInteractive, onToggle }: ToggleChartInteractionProps) => {
  return <Button onClick={onToggle} icon={isInteractive ? <LockOutlined /> : <UnlockOutlined />} type='link'/>;
};

export default ToggleChartInteraction;
